import { render, staticRenderFns } from "./DeleteBookModal.vue?vue&type=template&id=1194d67e"
import script from "./DeleteBookModal.vue?vue&type=script&lang=js"
export * from "./DeleteBookModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports